module.exports = __webpack_public_path__ + "static/media/view-skytree.2917c580.jpg";